import {useEffect, useMemo, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {useTextInput} from "./useTextInput";

export const useFilter = () => {
    const paramQuery = "q"

    const [searchParams, setSearchParams] = useSearchParams()
    const [filter, setFilter, showFilterHelp, setShowFilterHelp] = useTextInput(searchParams.get(paramQuery) || "")

    function handleOnClear() {
        setFilter("")
        setShowFilterHelp(false)
        setSearchParams(prev => {
            prev.set(paramQuery, "")
            return prev
        }, {replace: true})
    }

    function handleKeyUp(e) {
        if (e.keyCode === 13 || e.target.value === "") { // Trigger search
            setShowFilterHelp(false)
            setSearchParams(prev => {
                prev.set(paramQuery, e.target.value)
                return prev
            }, {replace: true})
        }
    }

    function handleOnChange(e) {
        setFilter(e.target.value)
        setShowFilterHelp(true)
    }

    return [filter || "", searchParams.get(paramQuery) || "", handleOnClear, handleOnChange, handleKeyUp, showFilterHelp]
}

export const useLocalFilter = (items, filter, attributes = []) => {
    const _filter = filter || ""
    return useMemo(() => items ? items.filter(item => attributes.some(attribute => item[attribute].toLowerCase().includes(_filter.toLowerCase()))) : [], [items, filter])
}

export const useOrderBy = (orderOptions) => {
    const param = "o"

    const [searchParams, setSearchParams] = useSearchParams()
    const orderBy = Number(searchParams.get(param))

    function handleOnSelect(eventKey) {
        setSearchParams(prev => {
            prev.set(param, Number(eventKey))
            return prev
        }, {replace: true})
    }

    useEffect(() => {
        const order = searchParams.get(param)
        if (order)
            handleOnSelect(order)
    }, [])

    const orderByString = useMemo(() => orderOptions.find(o => o.id === orderBy)?.order || "", [orderBy])

    return [orderBy, handleOnSelect, orderByString]
}

export const useLocalOrderBy = (items, orderBy, orderOptions) => {
    return useMemo(() => {
        // TODO check if this function can be removed
        // return items
        // if (items.length === userCount) {
        // Skip server request a local re-ordering is enough
        const opt = orderOptions.find(o => o.id === orderBy)
        return opt ? items.sort(opt.sort) : items
        // }
        //return items
    }, [items, orderBy])
}

export const useOrderBy2 = (param = "by") => {
    return useFilterParam(param)
}

export const useFilterParam = (param) => {
    const [searchParams, setSearchParams] = useSearchParams()
    const value = searchParams.get(param)

    function setValue(newValue) {
        setSearchParams(prev => {
            if (newValue == null || newValue === "") {
                prev.delete(param)
            } else {
                prev.set(param, newValue)
            }
            return prev
        }, {replace: true})

    }

    return [value, setValue]
}

export const useSearchTerm = (param1 = "filter", param2 = "query") => {
    const [searchParams, setSearchParams] = useSearchParams()
    const [filter, setFilter] = useState(searchParams.get(param1) || searchParams.get(param2) || "")

    function handleOnClear() {
        setSearchParams(prev => {
            prev.delete(param1)
            prev.delete(param2)
            setFilter("")
            return prev
        }, {replace: true})
    }

    function handleKeyUp(e) {
        if (e.keyCode === 13) { // Trigger search
            setSearchParams(prev => {
                prev.delete(param1)
                prev.set(param2, e.target.value)
                setFilter(e.target.value)
                return prev
            }, {replace: true})
        } else if (e.target.value === "") {
            setSearchParams(prev => {
                prev.delete(param1)
                prev.delete(param2)
                setFilter("")
                return prev
            }, {replace: true})
        }
    }

    function handleOnChange(e) {
        setSearchParams(prev => {
            prev.set(param1, e.target.value)
            //if (prev.get())
            //prev.delete(param2)
            setFilter(e.target.value)
            return prev
        }, {replace: true})
    }

    return [filter, handleOnClear, handleOnChange, handleKeyUp, !!searchParams.get(param1)]
}

export const useLocalFilter2 = (items, attributes = [], filter = null) => {
    const [searchParams] = useSearchParams()
    const _filter = filter || searchParams.get("filter") || ""
    return useMemo(() => items ? items.filter(item => attributes.some(attribute => item[attribute]?.toLowerCase().includes(_filter.toLowerCase()))) : [], [items, _filter])
}